import React from "react";

const VehicleSearch = ({
  onSearch,
  veiculoOptions,
  selectedVeiculos,
  toggleSelecionado,
  normalizeOptionValue,
}) => {
  const selectedSet = new Set(
    (selectedVeiculos || []).map((option) => normalizeOptionValue(option))
  );

  return (
    <>
      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        <input
          type="text"
          placeholder="Buscar por frota..."
          onChange={(event) => onSearch(event.target.value)}
          style={{
            flex: 1,
            padding: 10,
            borderRadius: 8,
            border: "1px solid #ccc",
            boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)",
          }}
        />
      </div>

      <div
        style={{
          display: "grid",
          gap: 8,
          marginBottom: 20,
          background: "#fff",
          padding: 12,
          borderRadius: 10,
          boxShadow: "inset 0 0 4px rgba(0,0,0,0.05)",
        }}
      >
        {(veiculoOptions || []).length === 0 ? (
          <div style={{ color: "#999" }}>Nenhuma frota encontrada</div>
        ) : (
          (veiculoOptions || []).map((option, index) => {
            const normalizedOption = normalizeOptionValue(option);
            const checked = normalizedOption ? selectedSet.has(normalizedOption) : false;
            const optionKey = normalizedOption ?? `veiculo-${index}`;

            return (
              <label
                key={optionKey}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: "pointer",
                  color: "#333",
                }}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => toggleSelecionado(option)}
                  style={{ cursor: "pointer" }}
                />
                {option?.label}
              </label>
            );
          })
        )}
      </div>
    </>
  );
};

export default VehicleSearch;
